import { Component, OnInit } from '@angular/core';
import { AlertMessage } from '../../../models/alerts/alert';
import { AlertService } from '../../../services/alert.service';

@Component({
  selector: 'ztsi-snack-bar',
  templateUrl: './snack-bar.component.html',
  styleUrls: ['./snack-bar.component.css']
})
export class SnackBarComponent implements OnInit {
  public alert: AlertMessage;
  public alertClass: string;

  constructor(
    private alertService: AlertService) {
  }

  ngOnInit() {
    this.alertService.alertStatus.subscribe((source: AlertMessage) => {
      this.alert = { 
        message: source.message,
        iconClass: source.iconClass
      };

      if(source.message != null){
        this.alertClass = 'show';

        setTimeout(() =>{
          this.alertClass = '';
        }, 5000);
      }
    });
  }

  onCloseAlert(event: Event) {
      this.alertClass = ''
  }
}



// WEBPACK FOOTER //
// ./src/app/components/shared/snack-bar/snack-bar.component.ts